import Login from "./Login";
import DemoLanding from "./DemoLanding";
import { isDemoHost } from "../../utils/landingCompany";

// The bare "/" index route is shared by the normal login domain and the
// guest-demo hostname (e.g. demo.costsfirst.com). Everything else in the
// auth route tree (explicit /login, :landingCompanyName, ...) is untouched
// and always renders Login as before.
export default function AuthOrDemoEntry() {
  return isDemoHost() ? <DemoLanding /> : <Login />;
}
